import { render } from "./SimulatorPage.vue?vue&type=template&id=5b88a4c0&scoped=true"
import script from "./SimulatorPage.vue?vue&type=script&lang=js"
export * from "./SimulatorPage.vue?vue&type=script&lang=js"

import "./SimulatorPage.vue?vue&type=style&index=0&id=5b88a4c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b88a4c0"]])

export default __exports__